module.exports = __webpack_public_path__ + "static/media/effacer.37b30ece.png";